import React from 'react';
import AboutFeatured from '../components/AboutFeatured';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';

function About() {
    return (
        <>
            <Header1 />
            <section className='blog-wrapper news-wrapper section-padding'>
                <div className='container'>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="section-heading text-center" style={{marginTop: "2%"}}>
                                <h4>Cytocare Technologies (P) Ltd</h4>
                            </div>
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-md-12">
                            <div className="w-100 p-3">
                                <p className="mb-3 text-justify">
                                    Cytocare Technologies Pvt Ltd is a service provider for clinical researcher, Medical Oncologist, Haematologist and regulatory experts involved in cell processing and stem cell therapy. We endeavour to promote our diversity, so fostering the original thoughts and creativity. By partnering with the most artistic biotechnology in the globe we will continue to meet the requirement of our customer while searching for new opportunities to address unmet scientific and clinical needs
                                </p>
                                <p className="mb-3 text-justify">
                                    Our Research and Clinical application programs address Technologies such as stem cell collection, Cell processing (includes Cryopreservation and Cryo shipping), Cell separation and Transplantation. Partnering in cGMP laboratory ensure the production of desired cells for Cell based therapies of malignant and non-malignant blood diseases and its Regenerative medicine applications
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="divider my-2"></div>
                </div>
            </section>
            <AboutFeatured />
            <p className='text-center mb-5'>
                <strong>Stem cell therapy - Transfusion Medicine - Transplantation <br />Bio Banking - cGMP Products</strong>
            </p>
            <Footer1 />
        </>
    );
}

export default About;
